import type { Tabs } from '@/scopes/account/common/components/Hero'
import { shallow } from 'zustand/shallow'
import { BookingTags, Hero as CommonHero } from '@/scopes/account/common/components'
import { formatPeriod } from '@/scopes/account/common/formatters'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { useBookingDetailsStore } from '../../infrastructure/useBookingDetailsStore'
import {
  getBookingTitle,
  getDaysUntilDeparture,
  getGroupResponsiblePageUrl,
  getHeroBackgroundImageSrc,
  isBookingOnHolidays,
} from '../selectors'

export function Hero() {
  const locale = useConfiguration('locale')
  const bookingTitle = useBookingDetailsStore(getBookingTitle)
  const isOnHolidays = useBookingDetailsStore(isBookingOnHolidays)
  const daysUntilDeparture = useBookingDetailsStore(getDaysUntilDeparture)
  const getUrlForTab = useBookingDetailsStore(state =>
    getGroupResponsiblePageUrl(state),
  )
  const backgroundImageSrc = useBookingDetailsStore(getHeroBackgroundImageSrc)
  const {
    location,
    rawDepartureDate,
    rawReturnDate,
    isTotallySnow,
    isPrimavera,
    isAddedByYou,
    isGroupResponsible,
    isGroupBooking,
    isCancelled,
    bookingNumber,
    rebookedBookingNumber,
  } = useBookingDetailsStore(state => ({
    location: state.destination,
    rawDepartureDate: state.rawDepartureDate,
    rawReturnDate: state.rawReturnDate,
    isTotallySnow: state.isTotallySnow,
    isPrimavera: state.isPrimavera,
    isAddedByYou: state.isAddedByYou,
    isGroupResponsible: state.isGroupResponsible,
    isGroupBooking: state.isGroupBooking,
    isCancelled: state.isCancelled,
    bookingNumber: state.bookingNumber,
    rebookedBookingNumber: state.rebookedBookingNumber,
  }), shallow)

  const handleTabChange = (activeTab: Tabs) => {
    window.location.href = getUrlForTab(activeTab)
  }

  return (
    <CommonHero
      title={bookingTitle}
      bookingNumber={bookingNumber}
      location={location}
      period={formatPeriod(rawDepartureDate, rawReturnDate, locale, 'long')}
      tags={(
        <BookingTags
          isTotallySnow={isTotallySnow}
          isPrimavera={isPrimavera}
          isAddedByYou={isAddedByYou}
          isOnHolidays={isOnHolidays}
          daysUntilDeparture={isCancelled ? null : daysUntilDeparture}
          isGroupBooking={isGroupBooking}
          isBookingExchanged={Boolean(rebookedBookingNumber)}
          isCancelled={isCancelled}
        />
      )}
      backgroundImageSrc={backgroundImageSrc}
      activeTab={isGroupResponsible ? 'booking' : undefined}
      onTabChange={isGroupResponsible ? handleTabChange : undefined}
    />
  )
}
